import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectDealerSelected } from 'app/pages/Header/selectors';
import { hasDealerContext } from 'utils/hasDealerContext';

export type TemplateValuePreferencesBreadcrumb = {
  label: string;
  link?: string;
  isActive?: boolean;
};

export const useTemplateValuePreferencesPage = () => {
  const location = useLocation();
  const selectedDealer = useSelector(selectDealerSelected);

  const breadcrumbsList = useMemo((): TemplateValuePreferencesBreadcrumb[] => {
    const fromState = (
      location.state as
        | { breadcrumbsList?: TemplateValuePreferencesBreadcrumb[] }
        | null
    )?.breadcrumbsList;
    if (fromState?.length) {
      return fromState;
    }
    return [{ label: 'Template Value Preferences', isActive: true }];
  }, [location.state]);

  return {
    breadcrumbsList,
    hasDealer: hasDealerContext(selectedDealer),
  };
};
